export function StatusDot({ status, size = "sm" }) {
  const map = {
    red: "bg-[#C17D6E]",
    orange: "bg-[#D9A05B]",
    green: "bg-[#507A5E]",
  };
  const s = size === "lg" ? "h-3 w-3" : "h-2 w-2";
  return <span className={`inline-block rounded-full ${s} ${map[status] || "bg-[#8A847A]"}`} />;
}

export function StatusPill({ status, label }) {
  const styles = {
    red: "bg-[#F5D9D4] text-[#8a3f30] border-[#e2b3aa]",
    orange: "bg-[#F5E3C4] text-[#8a5f1e] border-[#e2ca97]",
    green: "bg-[#DCE8DF] text-[#2f5238] border-[#b3d0bb]",
    gray: "bg-[#F0EBE1] text-[#5C5850] border-[#E5E0D8]",
  };
  const cls = styles[status] || styles.gray;
  return (
    <span className={`inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full text-[11px] font-medium border ${cls}`}>
      <StatusDot status={status === "gray" ? "" : status} />
      {label}
    </span>
  );
}
